import viLocal from 'vant/lib/locale/lang/vi-VN'
import viJame from './languageJame/vi'
import viGaea from './languageGaea/vi'
import viAllen from './languageAllen/vi'
const vi = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: 'Sao chép thành công',
  300028: 'Sao chép không thành công',

  300029: 'Tải xuống SuperEx APP',
  300030: 'Giao dịch mọi lúc, mọi nơi',
  300031: 'Tạo tài khoản SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Email',
  300034: 'Di động',
  300035: 'Số điện thoại',
  300036: 'Mật khẩu',
  300037: 'ID giới thiệu (Tùy chọn)',
  300038: 'Tôi đã đọc và đồng ý với',
  300039: 'Điều khoản dịch vụ của SuperEx',
  300040: 'Tôi trên 18 tuổi và tôi đồng ý với các Điều khoản của SuperEx',
  300041: 'Đăng ký',
  300042: 'Xác minh bảo mật',
  300043: 'Chọn mã vùng',
  300044: 'Tìm kiếm',
  300045: 'Vui lòng nhập số điện thoại di động của bạn',
  300046: 'Vui lòng nhập số điện thoại di động chính xác',
  300047: 'Hãy điền địa chỉ email của bạn',
  300048: 'Vui lòng nhập một địa chỉ email hợp lệ',
  300049: 'Vui lòng nhập mật khẩu của bạn',
  300050: 'Ít nhất 8 ký tự, bao gồm cả chữ hoa và số',
  300051: 'Mã xác minh email',
  300052: 'Mã xác minh điện thoại',
  300053: 'Google / Microsoft Auth',
  300054: 'Google / Microsoft',
  300055: 'Để bảo mật tài khoản của bạn, vui lòng hoàn thành các thao tác xác minh sau',
  300056: 'Gửi đi',
  300057: 'Mã gồm 6 chữ số sẽ được gửi đến {phone}',
  300058: 'Mã sẽ được gửi đến {email}',
  300059: 'Vui lòng nhập mã xác minh SuperEx/Google/Microsoft gồm 6 chữ số',
  300060: 'Nhập mã xác minh gồm 6 chữ số',
  300061: 'Gửi mã',
  300062: 'Gửi lại sau {timeout} giây',
  300063: 'Ngôn ngữ',
  300064: 'Đang xem xét',
  300065: 'Nhập các chữ cái tiếng Anh hoặc các dấu câu thông dụng',


  300066: 'Trung tâm nhiệm vụ',
  300067: 'Trận chiến xếp hạng tiền thưởng',
  300068: 'Nhận lên đến <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em>!',
  300069: 'Mời',
  300070: 'Bảng xếp hạng',
  300071: 'Mở khóa quy tắc',
  300072: 'Nhận thêm ET',
  300073: 'Trận chiến xếp hạng tiền thưởng. Lên đến 1 BTC đang chờ bạn!',
  300074: 'Hoàn thành giao dịch để mở khóa ET',
  300075: 'Hoàn thành tất cả các nhiệm vụ trên để được đưa vào danh sách trắng và SuperEx sẽ phát ngẫu nhiên một lượng lớn mã thông báo ET cho người dùng trong danh sách cho phép theo thời gian.',
  300076: 'Xếp hạng hàng ngày',
  300077: 'Tổng xếp hạng',
  300078: 'Điều khoản dịch vụ',
  300079: 'Giải thưởng của tôi',

  300080: 'Số dư khóa',
  300081: 'Mở khóa số dư',
  300082: 'Số tiền mở khóa = phí giao dịch * độ khó mở khóa / giá ET',
  300083: 'Đi giao dịch',
  300084: 'Xếp hạng',
  300085: 'Tài khoản',
  300086: 'Nhiệm vụ',
  300087: 'Lưu ý: Xếp hạng hàng ngày được tính cho đến 0:00 của ngày (UTC-4) và phần thưởng sẽ được phát vào ngày hôm sau. Có thể có sai sót trong dữ liệu chỉ để tham khảo.',
  300088: 'Lưu ý: Phần thưởng sẽ được phát trong vòng 3 ngày làm việc sau khi sự kiện kết thúc, dữ liệu có thể có sai sót chỉ mang tính chất tham khảo.',
  300089: 'Xem thêm',

  300090: 'Đóng',
  300091: 'Bạn đã là một người dùng trong danh sách trắng!',
  300092: 'Nhập tài khoản {type} của bạn',
  300093: 'Bước cuối cùng',
  300094: 'Theo dõi chúng tôi trên Twitte',
  300095: 'Tham gia nhóm Telegram chính thức của chúng tôi',
  300096: 'Bắt đầu gửi tiền',
  300097: 'Bắt đầu giao dịch Spot',
  300098: 'Ngay lập tức tham gia giao dịch Futures',
  300099: 'Giới thiệu một người bạn để đăng ký',

  300100: 'Mời bạn bè giao dịch',
  300101: 'Giới thiệu một người bạn để giao dịch nhiều hơn',
  300102: 'Gửi',
  300103: 'Theo dõi',
  300104: 'Yêu cầu',
  300105: 'Đã thu thập (lần)',
  300106: 'Chưa mở',
  300107: 'Tham gia',
  300108: 'Không có dữ liệu được tìm thấy',
  300109: 'Hoàn thành',
  300110: 'Mời bạn bè và nhận thêm SCS',
  300111: 'Hủy bỏ',
  300112: 'Gửi đi',
  300113: 'Không gửi lại',
  300114: 'Hiện tại không có nhiệm vụ nào',
  300115: 'Hãy theo dõi để biết thêm nhiệm vụ',
  300116: 'Hãy theo dõi để biết thêm các sự kiện!',
  300117: 'Vui lòng nhập tài khoản của bạn',
  300118: 'Vui lòng nhập tài khoản của bạn',
  300119: 'Từ chối',
  300120: 'Đăng ký SuperEx ngay',
  300121: 'Đăng ký',
  300122: 'Hết hạn',
  300123: 'Whitepaper',

  300124: 'Phần thưởng Hộp bí ẩn',
  300125: 'Nhận phần thưởng 1.000 USDT từ Crypto Mystery Box với tỷ lệ thắng <em class="normal bold" style="color: #FFC72B">100%</em>',
  300126: 'Quy tắc',

  300127: 'Mở hộp bí ẩn',
  300128: 'Số lần rút thăm',
  300129: 'Còn lại (của tôi)',
  300130: 'Đã mở (Tổng USDT)',
  300131: 'Phần thưởng',
  300132: 'Làm thế nào để tham gia?',
  300133: 'Chia sẻ liên kết lời mời của bạn',
  300134: 'Hoàn thành nhiệm vụ',
  300135: 'Mời bạn bè đăng ký và hoàn thành nhiệm vụ giao dịch',
  300136: 'Nhận Hộp bí ẩn',

  300137: 'Hoàn thành nhiệm vụ và nhận Hộp bí ẩn',
  300138: 'Sự kiện này đã kết thúc, hãy đón chờ sự kiện tiếp theo!',
  300139: 'Sự kiện này vẫn chưa bắt đầu, vì vậy hãy theo dõi!',
  300140: 'Quy tắc sự kiện',
  300141: 'Đồng ý',
  300142: 'Thời gian',
  300143: 'Kiểm tra',
  300144: 'Xác thực email',
  300145: 'Mời bạn bè',
  300146: 'Thắp sáng đèn ma bí ngô và vui chơi <em class="normal" style="color: #FFC72B">Halloween</em>',
  300147: 'Đăng nhập trong <em class="normal" style="color: #FFC72B">{num}</em> ngày liên tục và có cơ hội giành được giải thưởng <em class="normal" style="color: #FFC72B">{amount} ET</em>',
  300148: 'Danh sách những người chiến thắng',
  300149: 'Đăng nhập hàng ngày',

  300150: 'Bạn đã đăng nhập {num} ngày',
  300151: 'Bốc thăm giải thưởng',
  300152: 'Đã đăng nhập',
  300153: 'Đăng nhập',
  300154: '',
  300155: '',
  300156: 'Đăng nhập',
  300157: 'Đã nhận được một phiếu tín dụng phí hợp đồng!',
  300158: 'Nâng cấp VIP thành công!',
  300159: 'Có cơ hội trúng xổ số!',

  300160: 'Phiếu giảm giá hợp đồng',
  300161: 'Nâng cấp VIP',
  300162: '',
  300163: 'Bạn có <em class="normal" style="color: #FFC72B">{num}</em> lần cơ hội đăng nhập lại',
  300164: 'Nhận cơ hội đăng nhập',
  300165: 'Có thể đăng nhập lại',
  300166: 'Lời khuyên',
  300167: 'Đã đăng nhập lại thành công',
  300168: 'Bạn chưa có số lần đăng nhập, bạn có thể nhận được 1 lần đăng nhập với khoản tiền gửi ròng ≥{num} {symbol} trong cùng một ngày.',
  300169: 'Đăng nhập',

  300170: 'Bạn đã đạt đến giới hạn đăng nhập lại',
  300171: 'Danh sách người chiến thắng gồm những người dùng đã đăng nhập trong 7 ngày liên tiếp',
  300172: 'Đăng nhập liên tục để nhận những phần thưởng sau',
  300173: 'Đã yêu cầu',
  300174: '{num} gày',
  300175: 'Phiếu mua hàng',
  300176: 'Cấp VIP của tôi',
  300177: 'Tham gia xổ số',
  300178: 'Xin chúc mừng!',
  300179: 'Đăng nhập thành công',
  300180: '',
  300181: 'Học viện',
  300182: 'Tin tức',
  300183: 'Dữ liệu',
  300184: 'Tìm hiểu',
  300185: 'Có cái nhìn chuyên sâu về các sự kiện lớn trong ngành tiền điện tử toàn cầu',
  300186: 'Xem tổng quan nhanh về các sự kiện mới nhất trong ngành tiền điện tử trên khắp thế giới',
  300187: 'Tìm hiểu mọi thứ về blockchain, Web3 và tiền điện tử',
  300188: 'Đọc thêm',
  300189: 'Video',
  300190: 'Đang tải',
  300191: 'Tất cả đã được tải lên',
  300192: 'Tất cả ',
  300193: 'Giải đấu chưa bắt đầu',
  300194: 'Chọn người chiến thắng World Cup để giành được <em class="normal" style="color:#DBFF00">Tiền thưởng</em> giới hạn',
  300195: 'Thời gian sự kiện',
  300196: 'Hồ sơ bình chọn',
  300197: 'Vòng bảng',
  300198: '{num} Nhóm',

  300199: 'Giải thưởng: {num} ',

  300200: 'Trợ giúp',
  300201: 'Giai đoạn loại trực tiếp',
  300202: 'Cuộc thi',
  300203: 'Thời hạn bình chọn',
  300204: 'Bỏ phiếu',
  300205: 'Vui lòng nhập số lượng  bình chọn',
  300206: 'Số lần đặt cược tối thiểu: {num} ET',
  300207: 'Thời gian dự đoán',
  300208: 'Đặt cược cho các đội',
  300209: 'Phiếu bầu',
  300210: 'Số tiền giải thưởng',
  300211: 'Các đội đủ điều kiện',
  300212: 'Ngày',
  300213: 'Giờ',
  300214: 'phút',
  300215: 'Giây',
  300216: 'Thời gian',
  300217: 'Sự kiện vẫn chưa bắt đầu',
  300218: '1/4 Chung kết',
  300219: 'Xác nhận',
  300220: 'Số lượng bình chọn',
  300221: 'Số dư không đủ',
  300222: 'Gửi',
  300223: 'Dự đoán thành công',
  300224: '1/8 Chung kết',
  300225: 'Bán kết',
  300226: 'Hạng ba và hạng tư vào chung kết',
  300227: 'Cuối cùng',
  300228: 'Chiến thắng',
  300229: 'Thất bại',
  300230: 'Tổng giải thưởng:{num} ET',
  300231: 'Xem thêm các trận đấu',
  300232: 'Các cuộc thi khác',
  300233: 'Tiền tệ',
  300234: 'Giá thị trường',
  300235: '24 giờ chg%',
  300236: 'Hướng dẫn người mới',
  300237: 'Bắt đầu học giao dịch tiền kỹ thuật số ngay bây giờ',
  300238: 'Sự hiện diện toàn cầu',
  300239: 'Không biên giới, phân quyền cộng đồng và quyền tự chủ, phân quyền nhóm là hình thức phát triển SuperEx cuối cùng',

  300240: 'Không có rủi ro bảo mật',
  300241: 'SuperWallet phi tập trung được tích hợp và khóa cá nhân được mã hóa và lưu trữ trên thiết bị người dùng. Không bị ảnh hưởng bởi bảo mật mã, chính trị và các yếu tố khác',
  300242: 'Không có đăng ký & KYC',
  300243: 'Các giao dịch được ủy quyền trên ví, không cần đăng ký, không cần KYC, thanh toán giao dịch được hoàn tất trên chuỗi, không thể giả mạo, an toàn và minh bạch',
  300244: 'Hệ thống mở',
  300245: 'Cho phép người dùng tương tác với Dapp hoặc hợp đồng thông minh, bằng cách mở SuperWallet, người dùng có thể được phép tham gia vào Meta, DeFi và NFTs',
  300246: 'Quỹ không gian',
  300247: 'Quỹ Không gian được sử dụng cho hoạt động khám phá không gian của con người hoặc tài trợ cho các tổ chức hoặc cá nhân có đóng góp đáng kể trong việc khám phá không gian của con người',
  300248: 'Một sàn giao dịch an toàn và dễ sử dụng',
  300249: 'Tải xuống ứng dụng di động SuperEX để theo dõi thị trường và thực hiện giao dịch vào thời điểm hoàn hảo, cho dù bạn ở đâu.',

  300250: 'Tải xuống khác',
  300251: 'Mọi giao dịch bạn thực hiện đều là nhiên liệu để con người bay vào vũ trụ',
  300252: 'Đăng ký ngay',
  300253: 'Quét iOS và Android để tải xuống',
  300254: 'Authenticator',
  300255: 'Xác thực Authenticator sẽ tạo mã xác minh 2 bước cho bạn. Giữ cho tài khoản SuperEx của bạn an toàn hơn với xác minh 2 bước.',
  300256: 'SuperEx Authenticator',
  300257: 'Google Auth',
  300258: 'Microsoft Auth',
  300259: 'Tải xuống ứng dụng (iPhone)',

  300260: 'Tải xuống ứng dụng (Android)',
  300261: 'Nền tảng giao dịch tài sản kỹ thuật số an toàn nhất trên thế giới！',
  300262: 'Về chúng tôi',
  300263: 'Điều kiện',
  300264: 'Sự riêng tư',
  300265: 'Thông báo',
  300266: 'Học viện',
  300267: 'Trung tâm dành cho người mới bắt đầu',
  300268: 'Giao dịch Spot',
  300269: 'Futures',

  300270: 'FAQ',
  300271: 'Dịch vụ',
  300272: 'Phí',
  300273: 'Quy tắc',
  300274: 'Danh sách ứng dụng',
  300275: 'Giới thiệu',
  300276: 'Liên hệ chúng tôi',
  300277: 'Trung tâm trợ giúp',
  300278: 'Gửi yêu cầu',
  300279: 'Liên hệ công việc',

  300280: 'Thể chế hợp tác',
  300281: 'Nhiều hơn',
  300282: 'Chào mừng trở lại!',
  300283: 'Quên mật khẩu?',
  300284: 'Vẫn chưa có tài khoản?',
  300285: 'Truy cập APP hoặc máy tính để khôi phục mật khẩu',
  300286: 'Đồng ý',

  300287: 'Xác nhận',
  300288: 'Được thông báo',
  300289: 'Để được nhận',

  300290: 'Đã tham gia',
  300291: 'Đã hoàn tiền',
  300292: 'Quy tắc mua hàng',
  300293: "Mua <span style='color: #ffc72b;'>Vật phẩm</span>",
  300294: 'Chọn và mua hàng',
  300295: 'Đang chờ kết quả',
  300296: 'Nhận vật phẩm',
  300297: 'Gửi',
  300298: 'Mua bản ghi',
  300299: 'Danh sách vật phẩm',
  300300: 'Phí tham gia một lần',
  300301: '{num} bản sao đã được bán. Vật phẩm sẽ được bán sau khi đạt {price} {currency}.',
  300302: 'Tham gia ngay',
  300303: 'Tham gia lại',
  300304: 'Chọn số lượng bản sao để mua',
  300305: "1 bản sao yêu cầu <span style='color: #fa4d56;'>{minPrice} {currency}</span> và một vật phẩm có thể được mua tối đa",
  300306: 'bản sao',
  300307: 'Bạn có {num} {currency}, mua càng nhiều thì cơ hội trúng thưởng càng cao!',
  300308: 'Mua',
  300309: 'Наступного разу',
  // 300309: '余额充值',
  300310: 'Chúc mừng!',
  300311: 'Yêu cầu',
  300312: 'Thử lại!',
  300313: 'Hoàn thành việc gửi tiền điện tử hoặc P2P trên APP.',
  // 300314: '我知道了',
  300315: 'Liên hệ với dịch vụ khách hàng trên ứng dụng để nhận vật phẩm.',
  // 300316: '我知道了',
  300317: 'Đăng nhập / Đăng ký',
  300318: 'Chi phí {num} {currency}',
  300319: 'Mô tả vật phẩm',
  300320: 'Sự tham gia của tôi',
  300321: 'Thời gian',
  300322: 'Hạng mục tham gia',
  300323: 'Số bản đã mua',
  300324: 'Số tiền hoàn trả',
  300325: 'Hoạt động',
  300326: 'Yêu cầu',
  300327: 'Bạn có sẵn sàng để tạo một tài khoản?',
  300328: 'Đăng nhập',
  300329: 'Mã xác thực',
  300330: 'Chỉ hiển thị hồ sơ từ bảy ngày qua',
  300331:'Authenticator',
  300332:'Tải xuống',
  300333:'1 USDT có thể mua 1 Bitcoin',
  300334:"Giá mua",
  300335:"Kết quả trước đó",
  300336:"期次",
  300337:"Xem quy tắc",
  300338:"Sự cố: [Phase {num}]",
  300339:"Quy trình mua hàng",
  300340:"Người dùng đã mua thành công",
  300341:"Thời gian thông báo",
  300342:"Chia sẻ",
  300343:"Vấn đề [{num}]",
  300345:"Tải xuống",
  300346:"Chia sẻ niềm vui của bạn",
  300347:"Quét mã để tham gia",
  300348:"Nhận vật phẩm",
  300349:"Lưu ý: Các vật phẩm tiền kỹ thuật số sẽ được gửi đến tài khoản của bạn trong vòng 48 giờ.",
  300350:"Liên hệ bộ phận chăm sóc khách hàng để yêu cầu các mặt hàng khác",
  300351:"Đi đến xem",
  300352:"Đăng ký ngay",
  300353:"Đã đăng kí",
  300354:'Đăng ký đã đóng',
  300355:'Đăng ký thành công',
  300356:'mở ứng dụng',
  300357:'Xin chúc mừng {user} đã có được {shop}!',
  300358:'Trung tâm tổ chức sự kiện',
  300359:'Trong quá trình',
  300360:'Bắt đầu sớm',
  300361:'Đã kết thúc',
  300362:'Tham gia ngay bây giờ',
  300363: 'Đã kết thúc',
  300364: 'Người chiến thắng',
  300365: 'Người chiến thắng sẽ được công bố sớm',
  300366: 'Tiền tệ',
  300367: 'Bán',
  200368: 'Thanh toán',
  300369: 'Nhận',
  300370: 'Được',
  300371: 'Hạn mức giao dịch duy nhất:',
  300372: 'Phương thức thanh toán',
  300373: 'Phương thức thanh toán',
  300374: 'Nhà cung cấp thanh toán',
  300375: 'Chi tiết lệnh',
  300376: 'Số tiền (bao gồm phí giao dịch)',
  300377: 'Thời gian đến',
  300378: 'Tuyên bố miễn trừ trách nhiệm',
  300379: 'Tôi đã đọc và đồng ý với tuyên bố từ chối trách nhiệm',
  300380: "Bạn sẽ rời SuperEx và chuyển sang <span>{name}</span>, một tổ chức tài chính được cấp phép cung cấp khả năng thanh toán thẻ với tư cách là bên thứ ba. Mọi rủi ro xảy ra trong quá trình sử dụng sẽ do <span>{name}</span> chịu trách nhiệm. Vui lòng đọc và đồng ý với <a class= 'pointer' href={server}>Thỏa thuận dịch vụ</a> của <span>{name}</span> trước khi sử dụng dịch vụ của nó\n" + "Nếu bạn có bất kỳ câu hỏi nào về việc nạp tiền vào thẻ tín dụng, vui lòng liên hệ với <a class='pointer' href={Customer}>{name} dịch vụ khách hàng</a> để biết thêm chi tiết.",
  300381: 'Làm cách nào để mua tiền điện tử trên SuperEx?',
  300382: 'Cách bán tiền điện tử trên SuperEx?',
  300383: 'Đặt lệnh tiền điện tử của bạn',
  300384: 'Chọn loại tiền pháp định bạn muốn thanh toán và tiền điện tử bạn muốn mua. Nhập số tiền bạn muốn chi tiêu.',
  300385: 'Xác minh danh tính của bạn',
  300386: 'Hoàn thành xác minh KYC trên SuperEx và nhà cung cấp dịch vụ thanh toán để hoàn tất thanh toán.',
  300387: 'Kiểm tra chi tiết lệnh của bạn',
  300388: 'Kiểm tra lịch sử gửi tiền của bạn để xem trạng thái lệnh của bạn.',
  300389: 'FAQ',
  300390: '1. Tôi có thể sử dụng phương thức thanh toán nào để mua tiền điện tử?',
  300391: 'SuperEx hiện hỗ trợ VISA, Mastercard, Apple Pay, Google Pay và các phương thức thanh toán khác. Các nhà cung cấp dịch vụ bên thứ ba được hỗ trợ bao gồm Mercuryo và alchemypay.',
  300392: '2. Tôi có thể mua loại tiền điện tử nào?',
  300393: 'SuperEx hỗ trợ các loại tiền điện tử phổ biến như BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV và TRX.',
  300394: '3. SuperEx có giám sát chất lượng và giá cả của các nhà cung cấp dịch vụ bên thứ ba được hỗ trợ không?',
  300395: 'SuperEx đã lựa chọn cẩn thận một số nhà cung cấp dịch vụ có uy tín, mức độ phổ biến và bảo mật đáng tin cậy trong ngành để cung cấp cho người dùng các dịch vụ hợp lý.',
  300396: '4. Tôi phải trả những khoản phí nào để mua tiền điện tử?',
  300397: 'Bạn trả phí cho nhà cung cấp dịch vụ bên thứ ba và phí chuyển tiền trên chuỗi. SuperEx không thu bất kỳ khoản phí nào.',
  300398: '5. Mất bao lâu để nhận được tiền điện tử sau khi thanh toán?',
  300399: 'Sau khi thanh toán của bạn hoàn tất trên nền tảng của nhà cung cấp dịch vụ bên thứ ba, tiền điện tử của bạn sẽ được gửi vào tài khoản giao ngay của bạn trên SuperEx trong khoảng 2–10 phút.',
  300400: '6. Nếu tôi gặp sự cố trong quá trình đặt lệnh thì sao?',
  300401: 'Liên hệ với bộ phận hỗ trợ khách hàng nếu bạn gặp bất kỳ vấn đề nào trong quá trình giao dịch. Nếu bạn chưa nhận được tiền điện tử sau khi thanh toán xong, hãy liên hệ với nhà cung cấp dịch vụ bên thứ ba để kiểm tra chi tiết đơn hàng (đây thường là phương pháp hiệu quả nhất). Do IP của khu vực hiện tại của bạn hoặc một số lý do chính sách nhất định, bạn sẽ phải chọn xác minh con người.',
  300402: "Khả dụng",
  300403: 'Không đủ số dư',
  300404: 'Please enter currency',
  300405: 'Nhập tiền tệ pháp định',
  300406: 'Bạn chưa hoàn thành xác minh danh tính',
  300407: "Để bảo mật tài khoản của bạn với những người dùng giao dịch khác, trước tiên vui lòng hoàn tất xác minh danh tính",
  300408: 'Được xác minh',
  300409: 'Chưa được xác minh',
  300410: 'Chọn tiền tệ',
  300411: 'Chọn tiền tệ pháp định',
  300412: 'All currencies',
  300413: 'Tất cả các loại tiền tệ Fiat',
  300414: '≈{time} phút',
  300415: 'Giao dịch P2P không mở cho người dùng ví được ủy quyền tại thời điểm này, vui lòng sử dụng tài khoản SuperEx của bạn để đăng nhập và giao dịch P2P',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'Mua',
  300418: 'Số sê-ri',
  300419: 'Lễ hội Halloween SuperEx',
  300420: 'Đăng nhập để tận hưởng quà tặng và giao dịch để giành được tiền thưởng!',
  300421:'Loại',
  300422:'Phần thưởng tiền điện tử',
  300423:'',
  300424:'',

  310000:'Tổng quan về phần thưởng',
  310001:'SCS Airdrop',

  400000:'Sàn giao dịch tiền điện tử Web3 đầu tiên',
  400001:'Tham gia cùng chúng tôi để tạo ra một thế giới tài chính',
  400002:'Mọi giao dịch bạn thực hiện đều là nhiên liệu để con người bay vào vũ trụ',
  400003:'Tóm tắt thú vị về SuperEX',
  400004:'Tích cực tham gia và chia sẻ nụ cười: Câu chuyện về bức tường hoạt động của chúng tôi',
  400005:'Chọn ngôn ngữ và khu vực',
  400006:'0 RISK',
  400007:'NO KYC',
  400008:'OPEN',
  400009:'FUND',
  400010:'Khám phá Mainnet',
  400011:'Khám phá Testnet',
  400012:'Tài liệu dành cho nhà phát triển',
  400013:'Khác',
  400014:'ET Zone',
  400015:'Kênh bán',

  400017: 'Nhập số điện thoại di động 11 chữ số',

  ...viLocal,
  ...viJame,
  ...viGaea,
  ...viAllen
}
export default vi;



// WEBPACK FOOTER //
// ./src/i18n/langs/vi.js